import "@/app/styles/footer.scss";
import contactData from "@/data/contact";
import Link from "next/link";
import Image from "next/image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faYoutube,
  faTiktok,
  faLine,
} from "@fortawesome/free-brands-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";

export default function Footer() {
  if (!contactData) {
    throw new Error("contactData is null or undefined");
  }

  return (
    <footer>
      <div className="footer-container">
        <div className="footer-top">
          <Link href="/" className="logo">
            <Image
              src="/cozyscape_logo.svg"
              alt="Cozy scape logo"
              width={50}
              height={50}
              // loading="lazy"
            />
          </Link>
          <div className="social-media">
            <h1>FOLLOW US</h1>
            <div className="icons">
              <Link
                href={contactData.facebook}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faFacebook} className="facebook" />
              </Link>
              <Link
                href={contactData.youtube}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faYoutube} className="youtube" />
              </Link>
              <Link
                href={contactData.tiktok}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faTiktok} className="tiktok" />
              </Link>
              <Link
                href={`https://line.me/R/ti/p/${contactData.lineID}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faLine} className="line" />
              </Link>
            </div>
          </div>
          <div className="contact-info">
            <h1>
              <FontAwesomeIcon icon={faPhone} className="icon" />
              CALL US
            </h1>
            <div>
              {contactData.phone
                ? contactData.phone.split(",").map((phone, index) => (
                    <p key={index} className="phone-br">
                      <a href={`tel:${phone.replace(/\s+/g, "")}`}>{phone}</a>
                    </p>
                  ))
                : null}
              {contactData.phone ? (
                <p className="phone-not-br">
                  <a href={`tel:${contactData.phone.replace(/\s+/g, "")}`}>
                    {contactData.phone}
                  </a>
                </p>
              ) : null}
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p> 2024 Cozyscape. Pathum thani, Thailand. All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
}
